import { create } from "zustand";
import type { PackageFileRef } from "../lib/matchSubmissionDocs";

interface PackageInventoryState {
  files: PackageFileRef[];
  status: "idle" | "scanning" | "done" | "error";
  error: string | null;
  scannedAt: string | null;
  foldersVisited: number;

  setScanning: () => void;
  setInventory: (files: PackageFileRef[], foldersVisited: number) => void;
  setError: (message: string) => void;
  clear: () => void;
}

export const usePackageInventoryStore = create<PackageInventoryState>(set => ({
  files: [],
  status: "idle",
  error: null,
  scannedAt: null,
  foldersVisited: 0,

  setScanning: () => set({ status: "scanning", error: null }),

  setInventory: (files, foldersVisited) =>
    set({
      files,
      status: "done",
      error: null,
      scannedAt: new Date().toISOString(),
      foldersVisited,
    }),

  setError: message => set({ status: "error", error: message }),

  clear: () =>
    set({
      files: [],
      status: "idle",
      error: null,
      scannedAt: null,
      foldersVisited: 0,
    }),
}));
